import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Loader2 } from "lucide-react";
import { Control } from "react-hook-form";
import { useCategories } from "../hooks/useCategories";
import { useTranslation } from "react-i18next";
import { Asterisk } from "lucide-react";

interface CategoryFieldProps {
  control: Control<any>;
  profile: any;
}

export function CategoryField({ control, profile }: CategoryFieldProps) {
  const { categories, loadingCategories } = useCategories(profile);
  const { t } = useTranslation();

  return (
    <FormField
      control={control}
      name="category_id"
      render={({ field }) => (
        <FormItem>
          <div className="flex items-center gap-2">
            <FormLabel>{t('profile.personalInfo.category')}</FormLabel>
            <Asterisk className="h-3 w-3 text-red-500" />
          </div>
          <Select
            disabled={loadingCategories}
            onValueChange={field.onChange}
            value={field.value}
          >
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder={t('profile.personalInfo.categoryPlaceholder')} />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {loadingCategories ? (
                <SelectItem value="loading">
                  <Loader2 className="h-4 w-4 animate-spin" />
                </SelectItem>
              ) : (
                categories?.map((category) => (
                  <SelectItem key={category.id} value={category.id}>
                    {category.name}
                  </SelectItem>
                ))
              )}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}